import React from 'react';
import {connect} from 'react-redux';
import {trans} from '../../../config/translation';

class LoginDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email   : '',
            password: '',
            errors  : {}
        }
    }

    /**
     * handle input change event and save it to state
     *
     * @param event
     */
    handleChange = (event) => {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
            errors             : {
                ...this.state.errors,
                [event.target.name]: false,
            }
        });
    }

    render() {
        if (this.props.user && this.props.user.email) {
            return (
                <div className="dropdown-menu dropdown-menu-right logout" id="navbar-login-dropdown"
                     aria-labelledby="navbar-dropdown-login">
                    {this.props.user.role === 'admin' || this.props.user.role === 'super-admin' ?
                        <a href='/webadmin' className="btn btn-block logout-button" target="_blank">Webadmin</a>
                        : ''}
                    <a href={window['changePasswordUrl']} className="btn btn-block logout-button">{trans('user.change-password')}</a>
                    <form className="" id="logout-form" action={window['logoutUrl']} method="POST">
                        <input type="hidden" name="_token" value={`${window['csrfToken']}`}/>
                        <button type="submit" className="btn btn-block logout-button">{trans('user.logout')}</button>
                    </form>
                </div>
            )
        }
        return (
            <div className="dropdown-menu dropdown-menu-right" id="navbar-login-dropdown"
                 aria-labelledby="navbar-dropdown-login">
                <div className="form-container">
                    <form method="POST" action={`${window['loginUrl']}`} encType="multipart/form-data">
                        <input type="hidden" name="_token" value={`${window['csrfToken']}`} />
                        <div className={`input-material-placeholder ${this.state.errors.email ? 'has-error' : ''}`}>
                            <input type="email" className="form-control" placeholder=" " name="email"
                                   autoComplete={'off'}
                                   value={this.state.email} onChange={this.handleChange}/>
                            <span className="placeholder">Email</span>
                        </div>
                        <div className={`input-material-placeholder ${this.state.errors.password ? 'has-error' : ''}`}>
                            <input type="password" className="form-control" placeholder=" " name="password"
                                   autoComplete={'off'}
                                   value={this.state.password} onChange={this.handleChange}/>
                            <span className="placeholder">Password</span>
                        </div>
                        <div className="btn-container">
                            <button type="submit" className="btn btn-primary">{trans('user.login')}</button>
                        </div>
                    </form>
                </div>
                <div className="forgot-password-container">
                    <a href={window['loginForgetUrl']}>{trans('user.forgot-password')}?</a>
                </div>
            </div>
        );
    }
}

const mapActionToProps = {}
const MapStateToProps = (state) => {
    return {
        user: state.user,
    }
}
export default connect(MapStateToProps, mapActionToProps)(LoginDropdown);